import React, { useRef, useState } from "react";
import PenSVG from "../../../assets/svg/PenSVG";
import { useDispatch } from "react-redux";
import { ImageMimeTypes } from "../../../utils/appConstants";
import { validateFileSize } from "../../helpers/formValidation";
import { FlashMessage, ProfileImageCrop } from "../../common";
import { fetchSessionDataRequest } from "../../../reducers/auth/session.reducer";
import candidateServices from "../../../services/candidate.services";

const Banner = ({ tokenData, publicPage }: { tokenData: any; publicPage?: boolean }) => {
  const [cropImage, setCropImage] = useState<any>(null);
  const [showCropImageBanner, setShowCropImageBanner] = useState(false);
  const [fileName, setFileName] = useState("");
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const dispatch = useDispatch();
  const hasBanner = Boolean(tokenData?.profile?.banner_image);

  const onChangeBanner = async (e: React.FormEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    const file = target.files?.[0];

    if (file) {
      const fileType = file.type;
      const fileSize = validateFileSize(file.size, 5);
      if (fileSize) {
        FlashMessage(fileSize, "error");
      } else if (ImageMimeTypes.includes(fileType)) {
        setFileName(file.name);
        const imageUrl = URL.createObjectURL(file);
        setCropImage(imageUrl);
        setShowCropImageBanner(true);
      } else {
        FlashMessage("Please select valid png or jpeg file", "error");
      }
    }
  };

  const handleCropImage = async (blobData: any) => {
    const payload = new FormData();
    payload.append("files", blobData, fileName);

    try {
      const response = await candidateServices.uploadCandidateBanner(payload);
      if (response?.flag) {
        FlashMessage("Banner image uploaded successfully");
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        dispatch(fetchSessionDataRequest());
        return true;
      }

      FlashMessage(response?.message || "Error uploading banner image", "error");
      return false;
    } catch (error) {
      FlashMessage("Error uploading banner image", "error");
      return false;
    }
  };

  return (
    <div
      className={`profile-banner${hasBanner ? " has-banner" : ""}`}
      style={{
        backgroundImage: hasBanner
          ? `url(${tokenData.profile.banner_image})`
          : "none",
      }}
    >
      {!publicPage && (
        <>
          <button
            type="button"
            className="banner-edit-btn"
            aria-label={hasBanner ? "Edit cover photo" : "Add cover photo"}
            onClick={() => fileInputRef.current?.click()}
          >
            <PenSVG />
          </button>

          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={onChangeBanner}
            style={{ display: "none" }}
          />
        </>
      )}

      <ProfileImageCrop
        layout={"banner"}
        visible={showCropImageBanner}
        cropImage={cropImage}
        btnCropText="Save"
        onClose={() => {
          setShowCropImageBanner(false);
        }}
        onCrop={(data) => handleCropImage(data)}
      />
    </div>
  );
};

export default Banner;
